
const firebaseConfig = {
    apiKey: "AIzaSyAz8cp8DsuXNiXwA03M6NEyGrN_fYOQVhc",
    authDomain: "stitchcraft-de55d.firebaseapp.com",
    projectId: "stitchcraft-de55d",
    storageBucket: "stitchcraft-de55d.appspot.com",
    messagingSenderId: "260321661546",
    appId: "1:260321661546:web:3a79ddf6fe65e71ac23013"
};



export default firebaseConfig;